import { useScroll, useSize } from 'ahooks';
import { Dialog, Grid, Image, Loading, Modal, Popover, Rate, Swiper, SwiperRef, Toast } from 'antd-mobile';
import { GridItem } from 'antd-mobile/es/components/grid/grid';
import { default as Img, default as img } from 'app/img';
import ImageList from 'components/dot/image-list';
import DOMPurify from 'dompurify';
import React, { useContext, useEffect, useRef, useState } from 'react';
import {
  AiFillBook,
  AiFillCloseCircle,
  AiFillFile,
  AiFillFileImage,
  AiFillFileText,
  AiFillFolder,
  AiFillHeart,
  AiFillInfoCircle,
  AiFillPlayCircle,
  AiOutlineArrowLeft,
  AiOutlineBook,
  AiOutlineBug,
  AiOutlineCloudDownload,
  AiOutlineEye,
  AiOutlineFile,
  AiOutlineFolder,
  AiOutlineFolderOpen,
  AiOutlineHeart,
  AiOutlineHome,
  AiOutlineLeft,
  AiOutlineLink,
  AiOutlineMessage,
  AiOutlineRight,
  AiOutlineRollback,
  AiOutlineShareAlt,
} from 'react-icons/ai';
import { TiArrowBack } from 'react-icons/ti';
import { useLocation, useNavigate } from 'react-router-dom';
import { PageQueryParams } from 'services/apis/cnt2/CommonDT';
import PostsApi, { PagePostDT, PostDetail, VideoPlayUrlList } from 'services/apis/cnt2/post-api';
import './index.css';
import myStyles from './index.module.scss';

import { useQuery } from '@tanstack/react-query';
import { ScreenTopContext } from 'App';
import VideoApi from 'services/apis/cnt/video-api';
import { termsDataType, TermsNodeListDT } from 'services/apis/cnt2/term-api';
import { UserDataType, UserPolyInfoDT } from 'services/apis/sys/user-api';
import { ExhentaiTagMap, P10ExhentaiContentBO, P10ExhentaiMetaBO } from 'services/gather_bo/10_exhentai';
import { P20IwaraContentBO, P20IwaraMetaBO, TagDTO } from 'services/gather_bo/20_iwara';
import { P30HanimeContentBO, P30HanimeMetaBO } from 'services/gather_bo/30_hanime1';
import {
  CircleDTO,
  P40AsmroneContentBO,
  P40AsmroneMetaBO,
  RateCountDetailDTO,
  Tracks,
  VasDTO,
} from 'services/gather_bo/40_asmrone';
import { P50BilinovelContentBO, P50BilinovelMetaBO } from 'services/gather_bo/50_bilinovel';
import { P60HentaiclubContentBO, P60HentaiclubMetaBO } from 'services/gather_bo/60_hentaiclub';
import { P70SndiaryContentBO, P70SndiaryMetaBO } from 'services/gather_bo/70_sndiary';
import { P80GameContentBO, P80GameMetaBO } from 'services/gather_bo/80_game';
import {
  BilinovelPostDetail,
  getCountOnSourceType,
  getStartTip,
  HentaiclubPostDetail,
  PostConentBOType,
  PostDetailType,
  PostMetaBOType,
  PostSourceType,
} from 'services/gather_bo/_total';
import { useImmer } from 'use-immer';
import { formatDateToChinese } from 'utils/dateUtil';
import { seconds2Duration } from 'utils/durationUtil';
import { beautyFileSize } from 'utils/fileUtil';
import { getItemWithExpiration } from 'utils/localStorageUtil';
import { scrollTop } from 'utils/screenUtil';

import ShareCypher, { ShareCypherDT } from 'components/dot/shareCypher';
import { bizBaseUrl } from 'services/request';
import Player, { PlayerDT } from '../func/player';

const Detail = () => {
  const navigate = useNavigate();
  const state = useLocation().state;
  const term = state?.term as TermsNodeListDT;
  const post = state?.post as PagePostDT;
  // console.log('state', state);

  const swiperRef = useRef<SwiperRef>(null);
  const [activePanelIndex, setActivePanelIndex] = useState<number>(1);
  const userPolyInfo = getItemWithExpiration('userPolyInfo') as UserPolyInfoDT;
  const usergroupId = userPolyInfo.vipList?.[0]?.fkUserGroupUuid;
  const collectListId = userPolyInfo.videoListDtoList.find((item) => item.listType === 'collect').uuid;
  const historyListId = userPolyInfo.videoListDtoList.find((item) => item.listType === 'history').uuid;
  const favoritelistId = userPolyInfo.videoListDtoList.find((item) => item.listType === 'favorite').uuid;

  const isFromSesame = (state?.isFromSesame || false) as boolean;
  // const [postDetail, setPostDetail] = useState<PostDetailType>();
  const tagMapList = useRef<[string, string[]][]>(null);
  const [osusumePostList, setOsusumePostList] = useState<PagePostDT[]>(null);
  const ref = useRef(null);
  const screenSize = useSize(ref);
  const isMarginTop0 = useRef(true);
  const [showPreview, toggleShowPreview] = useState(true);
  const previewCountInit = 9;
  const [previewCount, setPreviewCount] = useState(previewCountInit);
  const scroll = useScroll(document);
  const tagTranslateMap = new Map()
    .set('language', '语言')
    .set('parody', '情节')
    .set('female', '女性')
    .set('male', '男性')
    .set('artist', '作者')
    .set('character', '角色')
    .set('group', '团体')
    .set('fixed', '混合')
    .set('other', '其他')
    .set('category', '类型')
    .set('general', '特征');
  const [liked, toggleLiked] = useState(false);
  const [hoard, toggleHoard] = useState(false);
  const fetchPostDetail = async (
    params: {
      postId: any;
    },
    data: {}
  ) => {
    const response = await PostsApi.getDetail(params, data);
    if (response.code === 0 && response.successful) {
      // setPostDetail(postDetail);
      // console.log('postDetail', postDetail);
      return response.result;
    }
  };
  const [playerState, setPlayerState] = useState<PlayerDT>(null);
  const getVideoPlayUrl = async () => {
    const response = await PostsApi.getVideoPlayUrl(
      {},
      {
        postSourceType: fetchPostDetailQuery.data?.postSourceType,
        postSourceUrl: fetchPostDetailQuery.data?.postSourceUrl,
      }
    );
    if (response.code == 0 && response.successful) {
      console.log('result1', response);
      const result: VideoPlayUrlList = response.result;
      if (!result || result.length == 0) {
        Toast.show('诶，中国大陆 Player？');
        return;
      }
      // const proxyType: string = "system";
      const proxyType: string = 'cfWorks';
      // const proxyType: string = "cfPages";
      switch (proxyType) {
        case 'system':
          if (fetchPostDetailQuery.data?.postSourceType === 'post_20_iwara') {
            result.forEach((item) => {
              item.url = 'http://192.168.31.60:3000/iwara/' + item.url;
            });
          } else if (fetchPostDetailQuery.data?.postSourceType === 'post_30_hanime') {
            result.forEach((item) => {
              item.url = 'http://192.168.31.60:3000/hanime/' + item.url;
            });
          }
          break;
        case 'cfWorks':
          result.forEach((item) => {
            item.url = 'https://proxy.uutt.me/' + item.url.replace('https://', '');
          });
          break;
        case 'cfPages':
          result.forEach((item) => {
            item.url = 'https://cf-pages-proxy-572.pages.dev/' + item.url.replace('https://', '');
          });
          break;
      }
      console.log('result2', result);
      setPlayerState({
        logo: '/images/logo/uutt.png',
        pic: fetchPostDetailQuery.data?.postCoverUrlList[0],
        videoPlayUrlList: result,
      });
    } else {
      Toast.show(response.msg);
    }
  };
  const fetchUserVideoList = async () => {
    // 用户交互
    if (userPolyInfo) {
      // 查询是否收藏
      VideoApi.getRecordExists({
        postId: post.postUuid,
        videoListId: collectListId,
      }).then((resp) => {
        if (resp.code === 0 && resp.successful) {
          toggleHoard(resp.result);
        }
      });
      // 查询是否喜欢
      VideoApi.getRecordExists({
        postId: post.postUuid,
        videoListId: favoritelistId,
      }).then((resp) => {
        if (resp.code === 0 && resp.successful) {
          toggleLiked(resp.result);
        }
      });
      // 添加观看记录
      VideoApi.add2List({
        postId: post.postUuid,
        videoListId: historyListId,
      }).then((resp) => {
        if (resp.code === 0 && resp.successful) {
          // console.log('已添加观看记录);
        }
      });
    }
  };
  const fetchOsusume = async () =>
    fetchOsusumePagePost(
      {
        termId: term.termUuid,
        count: getCountOnSourceType(post.postSourceType)?.osusumeCount,
      },
      true
    );

  const fetchOsusumePagePost = async (
    params: {
      termId: string;
      count: number;
    },
    initial = false
  ) => {
    const response = await PostsApi.pageOsusume(params);
    if (response.code === 0 && response.successful) {
      if (initial) {
        setOsusumePostList(response.result.records);
      }
      return params;
    }
  };

  // 获取帖子详情
  const fetchPostDetailQuery = useQuery({
    queryKey: ['getDetail', post.postUuid],
    queryFn: () => {
      return fetchPostDetail({ postId: post.postUuid }, {});
    },
  });

  // 返回顶部，重置交互数据
  // 获取推荐, 添加浏览记录,
  useEffect(() => {
    scrollTop();
    setPlayerState(null);

    fetchOsusume();
    fetchUserVideoList();
  }, [post.postUuid]);

  // 初始化帖子详情数据
  useEffect(() => {
    const postDetail = fetchPostDetailQuery.data as PostDetailType;
    if (!postDetail) {
      return;
    }
    // exhentai
    const initial = true;
    if (initial && 'galleryOriginTitle' in postDetail?.postContentDto?.metaInfo) {
      tagMapList.current =
        postDetail?.postContentDto?.metaInfo?.tagMap && Object.entries(postDetail?.postContentDto?.metaInfo?.tagMap);
    }
    // iwara
    if (initial && 'body' in postDetail?.postContentDto?.metaInfo) {
      tagMapList.current =
        postDetail?.postContentDto?.metaInfo?.tags &&
        Object.entries(
          postDetail?.postContentDto?.metaInfo?.tags.reduce((acc, item) => {
            const { type, id } = item;
            if (!acc[type]) {
              acc[type] = [];
            }
            acc[type].push(id);
            return acc;
          }, {})
        );
    }
    // asmr
    if (initial && 'tracksList' in postDetail?.postContentDto?.contentInfo) {
      // 初始化 amsr目录 + 面包屑导航
      updateAsmrBreadcrumbList((draft) => {
        if (draft.tarckList.length === 0) {
          const tracksList = [...(postDetail?.postContentDto?.contentInfo as P40AsmroneContentBO).tracksList];
          tracksList.sort((a, b) => {
            // 先比较 type
            const typeComparison = a.type.localeCompare(b.type);
            // 如果 type 不同，直接返回比较结果
            if (typeComparison !== 0) {
              return typeComparison;
            }
            // 如果 type 相同，比较 title
            return a.title.localeCompare(b.title);
          });
          draft.tarckList.push({
            type: 'folder',
            title: 'ROOT',
            hash: '',
            lowQualityPath: '',
            highQualityPath: '',
            duration: 0,
            size: 0,
            children: tracksList,
          });
          console.log('asmrBreadcrumbList-init', draft);
        }
      });
    }
  }, [fetchPostDetailQuery.data]);

  // 设置滚动效果
  useEffect(() => {
    const top = scroll?.top || 0;
    const width = window.innerWidth || 9999;
    if (top <= width + 1) {
      isMarginTop0.current = true;
    } else {
      isMarginTop0.current = false;
    }
  }, [scroll]);

  const Fallback = (
    <img
      width={window.innerWidth}
      height={window.innerWidth * 0.75}
      src={img.fallbackVerticalImg}
      className="round-md object-cover"
    />
  );

  const SourceInfo: React.FC<{ postType: string }> = () => {
    let metaInfo: PostMetaBOType = fetchPostDetailQuery.data?.postContentDto?.metaInfo;
    let contentInfo: PostConentBOType = fetchPostDetailQuery.data?.postContentDto?.contentInfo;

    const navigateTermTag = (tagName: string) => {
      const term = fetchPostDetailQuery.data?.asTagList.find((item) => item.termName === tagName);
      console.log('asTagList', fetchPostDetailQuery.data?.asTagList, 'term', term, 'tagName', tagName);
      if (isFromSesame) {
        Toast.show('❤ 暂无权限 ❤');
        return;
      }
      if (term) {
        navigate('/term', {
          state: { term: term, termTaxonomy: 'tag' },
        });
      }
    };
    const navigateTermTopics = (topicsName: string) => {
      const term = fetchPostDetailQuery.data?.asTopicsList.find((item) => item.termName === topicsName);
      console.log('asTopicsList', fetchPostDetailQuery.data?.asTopicsList, 'term', term, 'topicsName', topicsName);
      if (isFromSesame) {
        Toast.show('❤ 暂无权限 ❤');
        return;
      }
      if (term) {
        navigate('/term', {
          state: { term: term, termTaxonomy: 'topics' },
        });
      }
    };

    return (
      <>
        {/* 类型保护用于后续使用 (通过使用条件分支检查特定属性, 可以推断出类型) */}
        {/* P10Exhentai */}
        {metaInfo && 'galleryOriginTitle' in metaInfo && (
          <>
            <div className=" flex-nowrap text-nowrap whitespace-nowrap m-2 rounded-md bg-slate-100 p-1 shadow-md text-start">
              <div className={[' flex gap-3 m-1 mt-1', !metaInfo?.galleryOriginTitle && 'hidden'].join(' ')}>
                <div className="w-10 min-w-10">原标题: </div>
                <div className="text-wrap">{metaInfo?.galleryOriginTitle}</div>
              </div>
              <div className=" flex flex-row m-1">
                <div className=" flex basis-1/2 gap-3">
                  <div className="w-10 min-w-10">分类: </div>
                  <div
                    className="  bg-gray-300 px-1.5 py-1 -mt-0.5 rounded-md shadow-sm"
                    onClick={() => {
                      //@ts-ignore
                      navigateTermTopics(metaInfo.galleryCategory);
                    }}
                  >
                    {metaInfo.galleryCategory}
                  </div>
                </div>
              </div>
              <div className=" flex m-1 gap-2">
                <div className="w-10 min-w-10">评分: </div>
                <div className=" flex items-center">
                  <Rate
                    allowClear
                    readOnly
                    allowHalf
                    count={5}
                    defaultValue={4.5}
                    value={Math.round(metaInfo?.scoreAverage * 2) / 2}
                    style={{ '--star-size': '14px' }}
                  />
                  {metaInfo.scoreAverage + ' 分 / ' + metaInfo?.scoreCount + ' 人'}
                </div>
              </div>
              <div className=" flex flex-row">
                <div className=" flex flex-col  basis-1/2">
                  <div className=" flex gap-3 m-1">
                    <div className="w-10 min-w-10">上传者: </div>
                    <div>{metaInfo?.uploader}</div>
                  </div>
                  <div className=" flex gap-3 m-1">
                    <div className="w-10 min-w-10">上传日: </div>
                    <div>{formatDateToChinese(new Date(metaInfo?.uploadTime).toLocaleDateString())}</div>
                  </div>
                </div>
                <div className=" flex flex-col  basis-1/2">
                  <div className=" flex gap-3 m-1">
                    <div className="w-10 min-w-10">页数: </div>
                    <div>{metaInfo?.pageCount + ' 页'}</div>
                  </div>
                  <div className=" flex gap-3 m-1">
                    <div className="w-10 min-w-10">大小: </div>
                    <div>{metaInfo.archiveSize}</div>
                  </div>
                </div>
              </div>
              <div>
                <div className=" flex gap-3 m-1">
                  <div className=" mt-1.5">标签: </div>
                  <div className=" flex flex-col">
                    {tagMapList?.current
                      ?.filter((item) => item[1] != null && item[1].length !== 0)
                      .map((item) => (
                        <div
                          className=" flex "
                          key={item[0]}
                        >
                          <div
                            className=" w-10 min-w-10 flex items-start pt-1.5"
                            key={item[0]}
                          >
                            {tagTranslateMap.get(item[0])}
                          </div>
                          <div className=" flex flex-wrap">
                            {item[1]?.map((item1) => (
                              <div
                                className="  bg-gray-300 px-1.5 py-1 m-0.5 rounded-md shadow-sm"
                                key={item1}
                                onClick={() => {
                                  //@ts-ignore
                                  navigateTermTag(item1);
                                }}
                              >
                                {item1}
                              </div>
                            ))}
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        {/* P20Iwara */}
        {metaInfo && 'body' in metaInfo && (
          <>
            <div className=" flex-nowrap text-nowrap whitespace-nowrap m-2 rounded-md bg-slate-100 p-1 shadow-md text-start">
              <div className=" flex gap-3 m-1 mt-2">
                <div>原创作者: </div>
                <div>{metaInfo?.nickname}</div>
              </div>
              <div className=" flex gap-3 m-1 mt-2">
                <div>上传日期: </div>
                <div>{metaInfo?.createdAt.toLocaleString().split(' ')[0]}</div>
              </div>
              <div className=" flex gap-3 m-1 mt-2">
                <div>视频分级: </div>
                <div
                  className="  bg-gray-300 px-1.5 py-1 -mt-0.5 rounded-md shadow-sm"
                  onClick={() => {
                    //@ts-ignore
                    navigateTermTopics(metaInfo?.rating.replaceAll('ecchi', 'R18'));
                  }}
                >
                  {metaInfo?.rating.replaceAll('ecchi', 'R18')}
                </div>
              </div>
              <div>
                <div className=" flex gap-3 m-1">
                  <div className=" mt-1.5">标签: </div>
                  <div className=" flex flex-col">
                    {tagMapList?.current
                      ?.filter((item) => item[1] != null && item[1].length !== 0)
                      .map((item) => (
                        <div
                          className=" flex "
                          key={item + ''}
                        >
                          <div
                            className=" w-10 min-w-10 flex items-start pt-1.5"
                            key={item[0]}
                          >
                            {tagTranslateMap.get(item[0])}
                          </div>
                          <div className=" flex flex-wrap">
                            {item[1]?.map((item1) => (
                              <div
                                className="  bg-gray-300 px-1.5 py-1 m-0.5 rounded-md shadow-sm"
                                key={item1}
                                onClick={() => {
                                  //@ts-ignore
                                  navigateTermTag(item1);
                                }}
                              >
                                {item1}
                              </div>
                            ))}
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
              {/* 帖子描述经常会有广告，或太长，就不显示了 */}
              {/* <div className=" flex gap-3 m-1 mt-2 text-wrap">
                <div className=" w-10 min-w-10">描述: </div>
                <div className=" text-wrap">{metaInfo?.body}</div>
              </div> */}
            </div>
          </>
        )}
        {/* P30Hanime */}
        {metaInfo && 'postDuration' in metaInfo && (
          <>
            <div className=" flex-nowrap text-nowrap whitespace-nowrap m-2 rounded-md bg-slate-100 p-1 shadow-md text-start">
              <div className=" flex">
                <div className=" basis-1/2">
                  <div className=" flex gap-3 m-1 mt-2">
                    <div>视频分类: </div>
                    <div
                      className="  bg-gray-300 px-1.5 py-1 -mt-0.5 rounded-md shadow-sm"
                      onClick={() => {
                        //@ts-ignore
                        navigateTermTopics(metaInfo?.postCategory);
                      }}
                    >
                      {metaInfo?.postCategory}
                    </div>
                  </div>
                  <div className=" flex gap-3 m-1 mt-2">
                    <div>视频时长: </div>
                    <div>{metaInfo?.postDuration}</div>
                  </div>
                </div>
                <div className=" basis-1/2">
                  <div className=" flex gap-3 m-1 mt-2">
                    <div>上传用户: </div>
                    <div>{metaInfo?.posterName}</div>
                  </div>
                  <div className=" flex gap-3 m-1 mt-2">
                    <div>上传日期: </div>
                    <div>{metaInfo?.postUploadTime.toLocaleString().split(' ')[0]}</div>
                  </div>
                </div>
              </div>
              <div>
                <div className=" flex gap-3 m-1">
                  <div className=" mt-1.5">视频标签: </div>
                  <div className=" flex flex-wrap">
                    {metaInfo?.tagsList.map((item) => (
                      <div
                        className=" flex flex-wrap"
                        key={item}
                      >
                        <div
                          className="  bg-gray-300 px-1.5 py-1 m-0.5 rounded-md shadow-sm"
                          key={item}
                          onClick={() => {
                            //@ts-ignore
                            navigateTermTag(item);
                          }}
                        >
                          {item}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        {/* P40Asmrone */}
        {metaInfo && 'nsfw' in metaInfo && (
          <>
            <div className=" flex-nowrap text-nowrap whitespace-nowrap m-2 rounded-md bg-slate-100 p-1 shadow-md text-start">
              <div className=" flex">
                <div className=" basis-1/2">
                  <div className=" flex gap-3 m-1 mt-2">
                    <div className=" w-14 w-min-14">年龄分级: </div>
                    <div
                      className="  bg-gray-300 px-1.5 py-1 -mt-0.5 rounded-md shadow-sm"
                      onClick={() => {
                        //@ts-ignore
                        navigateTermTopics(metaInfo?.ageCategoryString);
                      }}
                    >
                      {metaInfo?.ageCategoryString
                        .replaceAll('general', '全年龄')
                        .replaceAll('r15', 'R-15')
                        .replaceAll('adult', '成人向')}
                    </div>
                  </div>
                  <div className=" flex gap-3 m-1 mt-2">
                    <div className=" w-14 w-min-14">音频时长: </div>
                    <div>{seconds2Duration(metaInfo?.duration)}</div>
                  </div>
                </div>
                <div className=" basis-1/2">
                  <div className=" flex gap-3 m-1 mt-2">
                    <div className=" w-14 w-min-14">官方销量: </div>
                    <div>{metaInfo?.dlCount + ' 份'}</div>
                  </div>
                  <div className=" flex gap-3 m-1 mt-2">
                    <div className=" w-14 w-min-14">官方原价: </div>
                    <div>{metaInfo?.price + ' JPY'}</div>
                  </div>
                </div>
              </div>
              <div className=" flex">
                <div className=" basis-1/2">
                  <div className=" flex gap-3 m-1 mt-2">
                    <div className=" w-14 w-min-14">社团ID: </div>
                    <div>{metaInfo?.circle.sourceId}</div>
                  </div>
                  <div className=" flex gap-3 m-1 mt-2">
                    <div className=" w-14 w-min-14">社团名称: </div>
                    <div>{metaInfo?.circle.name}</div>
                  </div>
                </div>
                <div className=" basis-1/2">
                  <div className=" flex gap-3 m-1 mt-2">
                    <div className=" w-14 w-min-14">发行日期: </div>
                    <div>{metaInfo?.release}</div>
                  </div>
                  <div className=" flex gap-3 m-1 mt-2">
                    <div className=" w-14 w-min-14">有无字幕: </div>
                    <div>{metaInfo?.hasSubtitle ? '有字幕' : '无字幕'}</div>
                  </div>
                </div>
              </div>
              {/* <div className=" flex gap-3 m-1">
                <div className=" w-14 w-min-14">CV列表: </div>
                <div className=" flex text-wrap">
                  {metaInfo?.vas &&
                    Object.entries(metaInfo?.vas)
                      .map((item) => item[1].name)
                      .join(" , ")}
                </div>
              </div> */}
              <div className=" flex  basis-1/2 gap-3 m-1">
                <div className="w-14 min-w-14">总体评分: </div>
                <div className=" flex items-center">
                  <div className=" flex items-center">
                    <Rate
                      allowClear
                      readOnly
                      allowHalf
                      count={5}
                      defaultValue={4.5}
                      value={Math.round(metaInfo?.rateAverage2dp * 2) / 2}
                      style={{ '--star-size': '14px' }}
                    />
                    {metaInfo.rateAverage2dp + ' 分 / ' + metaInfo?.rateCount + ' 人'}
                  </div>
                </div>
              </div>
              <div className=" flex gap-3 m-1">
                <div className=" w-14 w-min-14 mt-2">CV列表: </div>
                {/* <div className=" flex text-wrap">
                  {metaInfo?.vas &&
                    Object.entries(metaInfo?.vas)
                      .map((item) => item[1].name)
                      .join(" , ")}
                </div> */}
                <div className=" flex flex-wrap">
                  {metaInfo?.vas &&
                    Object.entries(metaInfo?.vas)
                      .map((item) => item[1].name)
                      .map((item) => (
                        <div
                          className=" flex flex-wrap"
                          key={item}
                        >
                          <div
                            className="  bg-gray-300 px-1.5 py-1 m-0.5 rounded-md shadow-sm"
                            key={item}
                          >
                            {item}
                          </div>
                        </div>
                      ))}
                </div>
              </div>
              <div>
                <div className=" flex gap-3 m-1 mt-2">
                  <div className=" mt-1.5">作品标签: </div>
                  <div className=" flex flex-wrap">
                    {metaInfo?.tagList
                      .filter((item) => item != '')
                      .map((item) => (
                        <div
                          className=" flex flex-wrap"
                          key={item}
                        >
                          <div
                            className="  bg-gray-300 px-1.5 py-1 m-0.5 rounded-md shadow-sm"
                            key={item}
                            onClick={() => {
                              //@ts-ignore
                              navigateTermTag(item);
                            }}
                          >
                            {item}
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        {/* P50Bilinovel */}
        {metaInfo && 'novelIntro' in metaInfo && (
          <>
            <div className=" flex-nowrap text-nowrap whitespace-nowrap m-2 rounded-md bg-slate-100 p-1 shadow-md text-start">
              <div className={[' flex gap-3 m-1 mt-2', !metaInfo?.novelTitle2 && 'hidden'].join(' ')}>
                <div className=" w-14 w-min-14">小说别名: </div>
                <div>{metaInfo?.novelTitle2}</div>
              </div>
              <div className=" basis-1/2">
                <div className=" flex gap-3 m-1 mt-2">
                  <div className=" w-14 w-min-14">最近更新: </div>
                  <div>
                    {formatDateToChinese(new Date(metaInfo?.novelRenewDatetime).toLocaleDateString()) +
                      ' · 共' +
                      (fetchPostDetailQuery.data as BilinovelPostDetail).postContentDto.metaInfo.novelTotalVolumeCount +
                      ' 卷 ' +
                      (fetchPostDetailQuery.data as BilinovelPostDetail).postContentDto.metaInfo
                        .novelTotalChapterCount +
                      ' 章'}
                  </div>
                </div>
                <div className=" flex gap-3 m-1 mt-2">
                  <div className=" w-14 w-min-14">最新章节: </div>
                  <div>{metaInfo?.novelRenewSection}</div>
                </div>
              </div>
              <div className=" flex">
                <div className=" basis-1/3">
                  <div className=" flex gap-3 m-1 mt-2">
                    <div className=" w-14 w-min-14">连载状态: </div>
                    <div>{metaInfo?.novelSerialize}</div>
                  </div>
                  <div className=" flex gap-3 m-1 mt-2">
                    <div className=" w-14 w-min-14">动画化: </div>
                    <div>{metaInfo?.novelAnimated || '无'}</div>
                  </div>
                </div>
                <div className=" basis-1/3">
                  <div className=" flex gap-3 m-1 mt-2">
                    <div className=" w-6 w-min-6">分类: </div>
                    <div>{metaInfo?.novelCategory}</div>
                  </div>
                  <div className=" flex gap-3 m-1 mt-2">
                    <div className=" w-6 w-min-6">文库: </div>
                    <div
                      className="  bg-gray-300 px-1.5 py-1 -mt-0.5 rounded-md shadow-sm"
                      onClick={() => {
                        //@ts-ignore
                        navigateTermTopics(metaInfo?.novelLibrary);
                      }}
                    >
                      {metaInfo?.novelLibrary}
                    </div>
                  </div>
                </div>
                <div className=" basis-1/3">
                  <div className=" flex gap-3 m-1 mt-2">
                    <div className=" w-6 w-min-6">作者: </div>
                    <div>{metaInfo?.novelAuthor}</div>
                  </div>
                  <div className=" flex gap-3 m-1 mt-2">
                    <div className=" w-6 w-min-6">插画: </div>
                    <div>{metaInfo?.novelIllustrator}</div>
                  </div>
                </div>
              </div>
              <div>
                <div className=" flex gap-3 m-1">
                  <div className=" mt-1.5">标签: </div>
                  <div className=" flex flex-wrap">
                    {metaInfo?.novelTagList.map((item) => (
                      <div
                        className=" flex flex-wrap"
                        key={item + ''}
                      >
                        <div
                          className="  bg-gray-300 px-1.5 py-1 m-0.5 rounded-md shadow-sm"
                          key={item}
                          onClick={() => {
                            navigateTermTag(item);
                          }}
                        >
                          {item}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className=" basis-1/2">
                <div className=" flex gap-3 m-1 mt-2">
                  <div className=" w-14 w-min-14">总体评分: </div>
                  <Rate
                    allowClear
                    readOnly
                    allowHalf
                    count={5}
                    defaultValue={3.5}
                    value={Math.round((metaInfo?.novelScoreValue / 2) * 10) / 10} //把评分制从10分改为5分, 允许半分
                    style={{ '--star-size': '14px' }}
                  />
                  <div className=" pt-0.5">
                    {metaInfo?.novelScoreValue +
                      ' 分 / ' +
                      metaInfo?.novelScoreNumList.reduce((acc, cur) => acc + cur, 0) +
                      ' 人'}
                  </div>
                </div>
              </div>
              <div className=" basis-1/2">
                <div className=" gap-3 m-1 mt-2">
                  <div className=" w-14 w-min-14 mb-2">小说介绍: </div>
                  <div
                    className=" text-wrap"
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(metaInfo?.novelDesc),
                    }}
                  />
                </div>
              </div>
              {metaInfo.novelNotice && (
                <>
                  <div className=" basis-1/2">
                    <div className=" gap-3 m-1 mt-2 bg-slate-50 rounded-md shadow-md">
                      <div className=" w-14 w-min-14 mb-2">小说提示: </div>
                      <div
                        className=" text-wrap"
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(metaInfo?.novelDesc),
                        }}
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
          </>
        )}
        {/* P60Hentaiclub */}
        {metaInfo && 'postCate' in metaInfo && (
          <>
            <div className=" flex-nowrap text-nowrap whitespace-nowrap m-2 rounded-md bg-slate-100 p-1 shadow-md text-start">
              <div className=" flex gap-3 m-1 mt-2">
                <div>作品分类: </div>
                <div
                  className="  bg-gray-300 px-1.5 py-1 -mt-0.5 rounded-md shadow-sm"
                  onClick={() => {
                    //@ts-ignore
                    navigateTermTopics(metaInfo?.postCate);
                  }}
                >
                  {metaInfo?.postCate}
                </div>
              </div>
              <div className=" flex gap-3 m-1 mt-2">
                <div>图片数量: </div>
                <div>{metaInfo?.postImgCount}</div>
              </div>
              <div>
                <div className=" flex gap-3 m-1">
                  <div className=" mt-1.5">视频标签: </div>
                  <div className=" flex flex-wrap">
                    {metaInfo.postTagList.map((item) => (
                      <div
                        className=" flex flex-wrap"
                        key={item}
                      >
                        <div
                          className="  bg-gray-300 px-1.5 py-1 m-0.5 rounded-md shadow-sm"
                          key={item}
                          onClick={() => {
                            navigateTermTag(item);
                          }}
                        >
                          {item}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        {/* P70Sndiary */}
        {metaInfo &&
          ('postFeat' in metaInfo || fetchPostDetailQuery.data?.postSourceType === PostSourceType.P70Sndiary) && (
            <>
              <div className=" flex-nowrap text-nowrap whitespace-nowrap m-2 rounded-md bg-slate-100 p-1 shadow-md text-start">
                <div className=" flex gap-3 m-1 mt-2">
                  <div>参演人物: </div>
                  <div>
                    {(metaInfo as P70SndiaryMetaBO)?.postFeatList.map((item) => (
                      <div
                        className="  bg-gray-300 px-1.5 py-1 -mt-0.5 rounded-md shadow-sm"
                        key={item}
                        onClick={() => {
                          navigateTermTag(item);
                        }}
                      >
                        {item}
                      </div>
                    )) || '待补充'}
                  </div>
                </div>
                <div className=" flex gap-3 m-1 mt-2">
                  <div>上传时间: </div>
                  <div>{(metaInfo as P70SndiaryMetaBO)?.postUpdateTime.toLocaleString().split(' ')[0]}</div>
                </div>
                <div>
                  <div className=" flex gap-3 m-1">
                    <div className=" mt-1.5">作品分类: </div>
                    <div className=" flex flex-wrap">
                      {(metaInfo as P70SndiaryMetaBO).postCateList.map((item) => (
                        <div
                          className=" flex flex-wrap"
                          key={item}
                        >
                          <div
                            className="  bg-gray-300 px-1.5 py-1 m-0.5 rounded-md shadow-sm"
                            key={item}
                            onClick={() => {
                              navigateTermTopics(item);
                            }}
                          >
                            {item}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        {/* P81Acggw, P82Vikacg, P83Acg91 */}
        {[
          PostSourceType.P81Acggw,
          PostSourceType.P82Vikacg,
          PostSourceType.P83Acg91,
          // PostSourceType.P91Acggw,
          // PostSourceType.P92Vikacg,
          // PostSourceType.P93Acg91,
        ].includes(fetchPostDetailQuery.data?.postSourceType) && (
          <>
            <div className=" flex-nowrap text-nowrap whitespace-nowrap m-2 rounded-md bg-slate-100 p-1 shadow-md text-start">
              <div className=" flex gap-3 m-1 mt-2">
                <div>上传用户: </div>
                <div>{(metaInfo as P80GameMetaBO)?.postUserName}</div>
              </div>
              <div className=" flex gap-3 m-1 mt-2">
                <div>上传时间: </div>
                <div>{(metaInfo as P80GameMetaBO)?.postUpdateTime.toLocaleString().split(' ')[0]}</div>
              </div>
              <div>
                <div className=" flex gap-3 m-1">
                  <div className=" mt-1.5">作品分类: </div>
                  <div className=" flex flex-wrap">
                    {(metaInfo as P80GameMetaBO).postCateList.map((item) => (
                      <div
                        className=" flex flex-wrap"
                        key={item}
                      >
                        <div
                          className="  bg-gray-300 px-1.5 py-1 m-0.5 rounded-md shadow-sm"
                          key={item}
                          onClick={() => {
                            navigateTermTopics(item);
                          }}
                        >
                          {item.includes('-') ? item.split('-')[1] : item}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div>
                <div className=" flex gap-3 m-1 -mt-1">
                  <div className=" mt-1.5">作品标签: </div>
                  <div className=" flex flex-wrap">
                    {(metaInfo as P80GameMetaBO).postTagList
                      .filter((item) => item != '')
                      .map((item) => (
                        <div
                          className=" flex flex-wrap"
                          key={item}
                        >
                          <div
                            className="  bg-gray-300 px-1.5 py-1 m-0.5 rounded-md shadow-sm"
                            key={item}
                            onClick={() => {
                              navigateTermTag(item);
                            }}
                          >
                            {item}
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </>
    );
  };

  const isP10 = () => {
    return (
      fetchPostDetailQuery.data?.postContentDto?.metaInfo &&
      'galleryOriginTitle' in fetchPostDetailQuery.data?.postContentDto?.metaInfo &&
      [PostSourceType.P10Exhentai].indexOf(fetchPostDetailQuery.data?.postSourceType) !== -1
    );
  };

  const isP20 = () => {
    return (
      fetchPostDetailQuery.data?.postContentDto?.metaInfo &&
      'body' in fetchPostDetailQuery.data?.postContentDto?.metaInfo &&
      [PostSourceType.P20Iwara].indexOf(fetchPostDetailQuery.data?.postSourceType) !== -1
    );
  };

  const isP30 = () => {
    return (
      fetchPostDetailQuery.data?.postContentDto?.metaInfo &&
      'postDuration' in fetchPostDetailQuery.data?.postContentDto?.metaInfo &&
      [PostSourceType.P30Hanime].indexOf(fetchPostDetailQuery.data?.postSourceType) !== -1
    );
  };

  const isP40 = () => {
    return (
      fetchPostDetailQuery.data?.postContentDto?.metaInfo &&
      'nsfw' in fetchPostDetailQuery.data?.postContentDto?.metaInfo &&
      'tracksList' in fetchPostDetailQuery.data?.postContentDto?.contentInfo &&
      [PostSourceType.P40Asmrone].indexOf(fetchPostDetailQuery.data?.postSourceType) !== -1
    );
  };

  const isP50 = () => {
    return (
      fetchPostDetailQuery.data?.postContentDto?.metaInfo &&
      'novelIntro' in fetchPostDetailQuery.data?.postContentDto?.metaInfo &&
      [PostSourceType.P50Bilinovel].indexOf(fetchPostDetailQuery.data?.postSourceType) !== -1
    );
  };

  const isP60 = () => {
    return (
      fetchPostDetailQuery.data?.postContentDto?.metaInfo &&
      'postCate' in fetchPostDetailQuery.data?.postContentDto?.metaInfo &&
      [PostSourceType.P60Hentaiclub].indexOf(fetchPostDetailQuery.data?.postSourceType) !== -1
    );
  };

  const isP70 = () => {
    return (
      fetchPostDetailQuery.data?.postContentDto?.metaInfo &&
      'postFeat' in fetchPostDetailQuery.data?.postContentDto?.metaInfo &&
      [PostSourceType.P70Sndiary].indexOf(fetchPostDetailQuery.data?.postSourceType) !== -1
    );
  };

  const isP80 = () => {
    return (
      fetchPostDetailQuery.data?.postContentDto?.metaInfo &&
      ['postDownloadHtml', 'postDownloadLimit', 'postPermissionHtml'].some(
        (prop) => fetchPostDetailQuery.data?.postContentDto?.metaInfo[prop]
      ) &&
      [
        PostSourceType.P81Acggw,
        PostSourceType.P82Vikacg,
        PostSourceType.P83Acg91,
        // PostSourceType.P91Acggw,
        // PostSourceType.P92Vikacg,
        // PostSourceType.P93Acg91,
      ].indexOf(fetchPostDetailQuery.data?.postSourceType) !== -1
    );
  };

  // 代码备忘录
  {
    let postDetail = fetchPostDetailQuery.data;
    let metaInfo: PostMetaBOType;
    let contentInfo: PostConentBOType;
    if (post.postSourceType === PostSourceType.P10Exhentai) {
      metaInfo = postDetail?.postContentDto?.metaInfo as P10ExhentaiMetaBO;
      contentInfo = postDetail?.postContentDto?.contentInfo as P10ExhentaiContentBO;
    }
    if (post.postSourceType === PostSourceType.P20Iwara) {
      metaInfo = postDetail?.postContentDto?.metaInfo as P20IwaraMetaBO;
      contentInfo = postDetail?.postContentDto?.contentInfo as P20IwaraContentBO;
    }
    if (post.postSourceType === PostSourceType.P30Hanime) {
      metaInfo = postDetail?.postContentDto?.metaInfo as P30HanimeMetaBO;
      contentInfo = postDetail?.postContentDto?.contentInfo as P30HanimeContentBO;
    }
    if (post.postSourceType === PostSourceType.P40Asmrone) {
      metaInfo = postDetail?.postContentDto?.metaInfo as P40AsmroneMetaBO;
      contentInfo = postDetail?.postContentDto?.contentInfo as P40AsmroneContentBO;
    }
    if (post.postSourceType === PostSourceType.P50Bilinovel) {
      metaInfo = postDetail?.postContentDto?.metaInfo as P50BilinovelMetaBO;
      contentInfo = postDetail?.postContentDto?.contentInfo as P50BilinovelContentBO;
    }
    if (post.postSourceType === PostSourceType.P60Hentaiclub) {
      metaInfo = postDetail?.postContentDto?.metaInfo as P60HentaiclubMetaBO;
      contentInfo = postDetail?.postContentDto?.contentInfo as P60HentaiclubContentBO;
    }
    if (post.postSourceType === PostSourceType.P70Sndiary) {
      metaInfo = postDetail?.postContentDto?.metaInfo as P70SndiaryMetaBO;
      contentInfo = postDetail?.postContentDto?.contentInfo as P70SndiaryContentBO;
    }
    if (post.postSourceType === (PostSourceType.P81Acggw || PostSourceType.P82Vikacg || PostSourceType.P83Acg91)) {
      metaInfo = postDetail?.postContentDto?.metaInfo as P80GameMetaBO;
      contentInfo = postDetail?.postContentDto?.contentInfo as P80GameContentBO;
    }
  }

  const [asmrBreadcrumbList, updateAsmrBreadcrumbList] = useImmer<{
    tarckList: Tracks[];
  }>({ tarckList: [] });
  const AsmrBreadcrumb: React.FC = () => {
    return (
      <nav
        //@ts-ignore
        // style={breadcrumbStyle}
        className={' flex flex-wrap items-center list-none p-0 m-0'}
      >
        {asmrBreadcrumbList.tarckList?.map((item, index) => (
          <span
            key={index}
            className={' flex items-center'}
          >
            {index !== asmrBreadcrumbList.tarckList.length - 1 ? (
              <div
                className=" flex items-center gap-1 text-blue-400"
                // style={breadcrumbLinkStyle}
                // onMouseOver={(e) => (e.currentTarget.style.textDecoration = "underline")}
                // onMouseOut={(e) => (e.currentTarget.style.textDecoration = "none")}
                onClick={() => {
                  // 修改面包屑导航 + 跳转目录
                  updateAsmrBreadcrumbList((draft) => {
                    draft.tarckList = draft.tarckList.slice(0, index + 1);
                  });
                }}
              >
                <AiFillFolder
                  color="#FFC107"
                  size={20}
                />
                <span>{item.title}</span>
              </div>
            ) : (
              <div className=" flex items-center gap-1">
                <AiFillFolder
                  color="#919191"
                  size={20}
                />
                <span>{item.title}</span>
              </div>
            )}
            {index < asmrBreadcrumbList.tarckList.length - 1 && <span className={' mx-2 text-slate-500'}>/</span>}
          </span>
        ))}
      </nav>
    );
  };

  // 分享助力

  const [showShareModal, setShowShareModal] = useState(false);
  const [mimeShareCypher, setMimeShareCypher] = useState<ShareCypherDT>(null);
  const shareCypher = async (data: ShareCypherDT) => {
    setMimeShareCypher(data);
    setShowShareModal(true);
  };

  const MaskContent = () => {
    return (
      <>
        <div>
          <center className=" text-base">
            <div className=" underline underline-offset-4 text-nowrap mb-3">口令模式</div>
            <div className=" text-nowrap">完整内容请【异次元空间】</div>
          </center>
          <div className=" mt-10 w-full text-center flex flex-col items-center justify-center">
            <div
              className="w-36 py-2 flex justify-center items-center gap-2 underline underline-offset-4 text-white text-base bg-gradient-to-r from-purple-500 to-pink-500 rounded-md shadow-md"
              onClick={() => {
                if (!usergroupId) {
                  Toast.show('❤ 暂无权限 ❤');
                } else {
                  Toast.show('即将进入异次元空间');
                  setTimeout(() => {
                    navigate('/one/home');
                  }, 3000);
                }
              }}
            >
              <AiOutlineRight /> <div>异次元空间</div>
              <AiOutlineLeft />
            </div>
          </div>
        </div>
      </>
    );
  };

  // 页面内容
  return (
    <>
      <ShareCypher
        mimeShareCypher={mimeShareCypher}
        showShareModal={showShareModal}
        setShowShareModal={(showShareModal) => {
          setShowShareModal(showShareModal);
        }}
      />
      <div key="detail">
        {/* 顶部反馈 */}
        <div
          className={[
            ' fixed top-0 w-full text-center flex justify-between items-center gap-5 p-2 transition-all transition-100 z-10 backdrop-blur-sm',
            // isMarginTop0.current ? 'bg-black/30 ' : 'bg-orange-400/100',
            isMarginTop0.current ? 'bg-black/30 ' : 'bg-black/30',
          ].join(' ')}
        >
          <div className=" flex justify-between items-center gap-5">
            <AiOutlineArrowLeft
              size={24}
              color="white"
              onClick={() => {
                if (isFromSesame) {
                  navigate('/sesame');
                } else {
                  scrollTop();
                  window.history.go(-1);
                }
                // navigate("/", { state: { screenTop: screenTop } });
                // navigate("/one/home");
              }}
            />
            <AiOutlineHome
              size={24}
              color="white"
              onClick={() => {
                if (isFromSesame) {
                  navigate('/sesame');
                } else {
                  scrollTop();
                  navigate('/one/home');
                }
                scrollTop();
              }}
            />
          </div>
          <div className=" flex justify-between items-center gap-2 text-base text-white">
            <div
              className=" flex items-center p-1 justify-center gap-0.5 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-md shadow-md "
              onClick={() => {
                shareCypher({
                  cypher: '待生成',
                  postId: post.postUuid,
                  postTitle: post.postTitle,
                  postCover: post.postCoverUrlList[0],
                  postSourceType: post.postSourceType,
                });
              }}
            >
              <AiOutlineShareAlt size={22} />
              <div className=" text-sm ">分享助力</div>
            </div>
          </div>
          {/* <AiOutlineBug
              size={22}
              color="white"
              onClick={() => {
                Toast.show("请通过站内信联系管理员");
              }}
            /> */}
        </div>
        {/* 视频播放器 */}
        {(isP20() || isP30()) && playerState != null && (
          <>
            {/* <div className=" h-0.5"></div> */}
            <div className=" pt-10 bg-black/80 text-white">
              <div className=" text-[10px] text-center text-nowrap pt-4 pb-3">
                请勿在行政网，校园网内使用，如果视频加载失败，请尝试科学上网。
              </div>
              <Player playerData={playerState} />
              <div
                className={[
                  true && 'hidden', // 跳转视频来源
                  ' w-full text-center p-3 text-sm text-white bg-black bg-opacity-50 font-bold',
                ].join(' ')}
              >
                {fetchPostDetailQuery.data?.postTitle}
                <a
                  href={post.postSourceUrl}
                  target="_blank"
                >
                  <AiOutlineLink
                    size={20}
                    color="#FB923C"
                    className=" inline-block mx-2"
                  />
                </a>
              </div>
            </div>
          </>
        )}
        {/* 封面 */}
        {(!isP20() || !isP30()) && playerState == null && (
          <>
            {/* 顶部大图 */}
            <div
              className=" relative"
              ref={ref}
              style={{
                // display: "flex",
                justifyContent: 'center',
                alignItems: 'center',
                // width: "100%",
                // height: "100%",
                overflow: 'hidden', // 确保图片不会超出容器
              }}
            >
              {/* 虚化背景 */}
              <div
                style={{
                  background: 'url(' + post.postCoverUrlList[0] + ') center center / cover no-repeat',
                  filter: 'brightness(50%) blur(10px)', // 减少亮度并添加高斯模糊
                  width: window.innerWidth,
                  height: window.innerWidth * 0.75,
                }}
                className=" object-cover"
              />
              <img
                src={post.postCoverUrlList[0]}
                className=" absolute top-20 left-8 rounded-xl shadow-md"
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  maxWidth: window.innerWidth * 0.4,
                  maxHeight: window.innerWidth * 0.4,
                  objectFit: 'contain',
                }}
              />
              <div className=" absolute w-full bottom-0 text-center p-3 text-sm text-white bg-gradient-to-r from-black/10 via-black/50 to-black/10  font-bold">
                {post?.postTitle}
              </div>
            </div>
            {/* 点击条 */}
            <div className=" flex gap-0.5">
              {/* 查看介绍 */}
              <div
                className={[
                  ' p-3 bg-orange-500 text-base text-white font-bold text-center basis-2/3 grow',
                  [
                    PostSourceType.P70Sndiary,
                    PostSourceType.P81Acggw,
                    PostSourceType.P82Vikacg,
                    PostSourceType.P83Acg91,
                    // PostSourceType.P91Acggw,
                    // PostSourceType.P92Vikacg,
                    // PostSourceType.P93Acg91,
                  ].indexOf(fetchPostDetailQuery.data?.postSourceType) === -1 && 'hidden',
                ].join(' ')}
                onClick={() => {
                  // if (!isFromSesame && !usergroupId) {
                  //   Toast.show("请先开通VIP");
                  //   return;
                  // }
                  navigate('/reader-article', {
                    state: {
                      postCover: fetchPostDetailQuery.data?.postCoverUrlList[0],
                      ...fetchPostDetailQuery.data,
                    },
                  });
                }}
              >
                查看介绍
              </div>
              {/* 下载合集/在线播放 */}
              <div
                className=" p-3 bg-orange-400 text-base text-white font-bold text-center grow"
                onClick={async () => {
                  // if (!isFromSesame && !usergroupId) {
                  //   Toast.show("请先开通VIP");
                  //   return;
                  // }
                  if (isP10() || isP60()) {
                    navigate('/reader-picture', {
                      // navigate(isP10() ? '/reader-manga' : '/reader-image', {
                      state: {
                        postTitle: fetchPostDetailQuery.data?.postTitle,
                        chapterList:
                          //@ts-ignore
                          fetchPostDetailQuery.data?.postContentDto.contentInfo.chapterList,
                        chapterInex: 0,
                        imageInex: 0,
                      },
                    });
                  } else if (isP20() || isP30()) {
                    getVideoPlayUrl();
                  } else {
                    Toast.show('❤ 暂无权限 ❤');
                    // Toast.show('❤ 无下载权限 ❤');
                    // Toast.show('❤ 建设中 ❤');
                  }
                }}
              >
                {!fetchPostDetailQuery.data
                  ? '加载中'
                  : getStartTip(fetchPostDetailQuery.data?.postType, fetchPostDetailQuery.data?.postSourceType)}
              </div>
            </div>
          </>
        )}

        {/* 信息 */}
        <div>
          {/* 数据交互 */}
          <div className=" flex justify-around items-center text-center p-2 px-3 bg-slate-100">
            <div
              className=" flex flex-col justify-center items-center gap-1 basis-2/8"
              onClick={() => {
                if (!userPolyInfo) {
                  Toast.show('请先登录');
                  return;
                }
                const data = {
                  postId: fetchPostDetailQuery.data?.postUuid,
                  videoListId: favoritelistId,
                };
                toggleLiked(!liked);
                if (liked) {
                  // 取消喜欢
                  VideoApi.del4List(data);
                } else {
                  // 添加喜欢
                  VideoApi.add2List(data);
                }
              }}
            >
              {liked ? (
                <AiFillHeart
                  size={20}
                  color="red"
                />
              ) : (
                <AiOutlineHeart size={20} />
              )}
              <div>
                {Math.max(
                  post.asCoacts?.coactHoardCount || post.asCoacts?.coactFavorCount,
                  Math.round(post.asCoacts?.coactViewCount / 999)
                ) ||
                  // || getCoastCount("like")
                  '999+'}
                <span className=" ml-0.5">喜欢</span>
              </div>
            </div>
            <div
              className=" flex flex-col justify-center items-center gap-1 basis-2/8"
              onClick={() => {
                // setActivePanelIndex(3);
              }}
            >
              <AiOutlineMessage size={20} />
              <div>
                {!post.asCoacts?.coactCommentCount ? '99+' : Math.max(Math.ceil(10), post.asCoacts?.coactCommentCount)}
                <span className=" ml-0.5">评论</span>
              </div>
            </div>
            <div
              className=" flex flex-col justify-center items-center gap-1 basis-2/8"
              onClick={() => {
                // Toast.show("观看");
              }}
            >
              <AiOutlineEye size={20} />
              <div className=" ml-1.5">
                {post.asCoacts?.coactViewCount ||
                  // || getCoastCount("view")
                  '99999+'}
                <span className=" ml-0.5">观看</span>
              </div>
            </div>
            <div
              className=" flex flex-col justify-center items-center gap-1 basis-1/8"
              onClick={() => {
                if (!userPolyInfo) {
                  Toast.show('请先登录');
                  return;
                }
                toggleHoard(!hoard);
                const data = {
                  postId: fetchPostDetailQuery.data?.postUuid,
                  videoListId: collectListId,
                };
                if (hoard) {
                  // 取消收藏
                  VideoApi.del4List(data);
                } else {
                  // 添加收藏
                  VideoApi.add2List(data);
                }
              }}
            >
              {hoard ? (
                <AiFillBook
                  size={20}
                  color="red"
                />
              ) : (
                <AiOutlineBook size={20} />
              )}
              <div>收藏</div>
            </div>
            <div
              className=" flex flex-col justify-center items-center gap-1 basis-1/8 "
              onClick={() => {
                Toast.show('❤ 暂无权限 ❤');
                // Toast.show('❤ 无下载权限 ❤');
              }}
            >
              <AiOutlineCloudDownload size={20} />
              <div>下载</div>
            </div>
          </div>
          {/* 交互导航 */}
          <div className=" flex justify-around items-center text-base pt-2">
            {['详情', '目录', '评论']
              .filter((item, index) => {
                // 来自口令页面 / 没有目录, 则不显示"目录"
                // (isFromSesame || (index + 1 === 2 && !getCountOnSourceType(post?.postSourceType)?.hasMenu)) &&
                //   ' hidden',
                if (item == '目录') {
                  if (!getCountOnSourceType(post?.postSourceType)?.hasMenu) {
                    return false;
                  }
                }
                return true;
              })
              .map((item, index) => (
                <div
                  key={index}
                  className={[
                    activePanelIndex === index + 1 ? ' border-orange-400' : ' border-transparent',
                    'border-b-4 px-5 p-1 text-slate-800/60',
                  ].join(' ')}
                  onClick={() => {
                    setActivePanelIndex(index + 1);
                    swiperRef.current?.swipeTo(index);
                  }}
                >
                  {item}
                </div>
              ))}
          </div>
          {/* 详情/目录/评论 */}
          <Swiper
            ref={swiperRef}
            defaultIndex={0}
            tabIndex={activePanelIndex}
            indicator={(total, current) => <></>}
            onIndexChange={(index) => {
              setActivePanelIndex(index + 1);
            }}
            className={[
              myStyles.customStyles,
              ' pb-5 pt-1 bg-gradient-to-br from-purple-100 to-orange-100 min-h-56',
            ].join(' ')}
          >
            {/* 详情 */}
            {true && (
              <Swiper.Item>
                <div className=" p-1 ">
                  {/* 元数据 */}
                  <div
                    className={[
                      ' m-2 border rounded-xl bg-gradient-to-br from-purple-300 to-orange-300 shadow-md',
                    ].join(' ')}
                  >
                    {/* 加载中 */}
                    {!fetchPostDetailQuery.data ? (
                      <div className=" h-96 m-2 flex justify-center items-center text-sm text-slate-500 bg-slate-100 rounded-md shadow-md">
                        加载中
                      </div>
                    ) : (
                      <SourceInfo postType={post.postSourceType} />
                    )}
                  </div>
                  {/* 推荐 */}
                  {true && (
                    <div
                      key={'osusume'}
                      className=" relative mt-3"
                    >
                      <ImageList
                        isFake={!osusumePostList}
                        termName="相关推荐"
                        termId={term.termUuid}
                        postList={osusumePostList}
                        showMore={false}
                        showChange={true}
                        onChange={() => {
                          // if (isFromSesame) {
                          //   Toast.show('❤ 没有口令捏~ ❤');
                          //   return;
                          // }
                          fetchOsusume();
                          window.scrollTo({
                            top: document.getElementById('osusume').offsetTop - 60,
                          });
                        }}
                        maskContent={isFromSesame && osusumePostList && <MaskContent />}
                      />
                    </div>
                  )}
                </div>
              </Swiper.Item>
            )}
            {/* 目录 */}
            {getCountOnSourceType(post?.postSourceType)?.hasMenu && (
              <Swiper.Item>
                <div className=" relative">
                  <div className=" px-0.5 min-h-96 m-2.5 my-3">
                    {/* P10Exhentai */}
                    {isP10() && 'chapterList' in fetchPostDetailQuery.data?.postContentDto?.contentInfo && (
                      <>
                        <div className=" flex-nowrap text-nowrap whitespace-nowrap rounded-md ">
                          {new Array(1).fill(0).map((item, index) => (
                            <div key={'P10_' + item.chapterNo}>
                              <div className=" flex justify-between bg-gradient-to-r from-slate-500/80 to-slate-500/30 text-white rounded-md mb-2">
                                <div className=" flex justify-center items-center gap-2">
                                  <div>{'第 ' + (index + 1) + ' 话'}</div>
                                  <div>
                                    {'共 ' +
                                      //@ts-ignore
                                      fetchPostDetailQuery.data?.postContentDto.metaInfo.pageCount +
                                      ' 页'}
                                  </div>
                                </div>
                                <div className=" flex justify-center items-center gap-2">
                                  <div
                                    className=" flex justify-center items-center gap-2 bg-red-400 p-2 px-3"
                                    onClick={() => {
                                      toggleShowPreview(!showPreview);
                                    }}
                                  >
                                    <div>{'查看预览'}</div>
                                    <AiOutlineFolderOpen size={22} />
                                  </div>
                                  <div
                                    className=" flex justify-center items-center gap-2 bg-orange-400 rounded-r-md p-2 px-3"
                                    onClick={() => {
                                      // if (!isFromSesame && !usergroupId) {
                                      //   Toast.show("请先开通VIP");
                                      //   return;
                                      // }
                                      navigate('/reader-picture', {
                                        // navigate('/reader-manga', {
                                        state: {
                                          postTitle: fetchPostDetailQuery.data?.postTitle,
                                          chapterList:
                                            //@ts-ignore
                                            fetchPostDetailQuery.data?.postContentDto.contentInfo.chapterList,
                                          chapterInex: 0,
                                          imageInex: 0,
                                        },
                                      });
                                    }}
                                  >
                                    <div>{'开始阅读'}</div>
                                    <AiOutlineEye size={22} />
                                  </div>
                                </div>
                              </div>
                              <Grid
                                columns={3}
                                gap={8}
                                className={[
                                  'bg-gradient-to-br from-slate-500/30 to-slate-500/80 p-2 rounded-md',
                                  showPreview ? 'visible' : 'invisible',
                                ].join(' ')}
                              >
                                {//@ts-ignore
                                fetchPostDetailQuery.data?.postContentDto.contentInfo.chapterList
                                  .slice(0, previewCount)
                                  .map((item3, index) => (
                                    <GridItem
                                      key={index}
                                      className={[
                                        ' flex justify-center flex-col items-center  text-white rounded-md shadow-md',
                                        index !== previewCount - 1 ? 'bg-slate-600' : 'bg-slate-600',
                                      ].join(' ')}
                                      onClick={() => {
                                        // if (!isFromSesame && !usergroupId) {
                                        //   Toast.show("请先开通VIP");
                                        //   return;
                                        // }
                                        if (index !== previewCount - 1) {
                                          navigate('/reader-picture', {
                                            // navigate('/reader-manga', {
                                            state: {
                                              postTitle: fetchPostDetailQuery.data?.postTitle,
                                              chapterList:
                                                //@ts-ignore
                                                fetchPostDetailQuery.data?.postContentDto.contentInfo.chapterList,
                                              chapterInex: 0,
                                              imageInex: index,
                                            },
                                          });
                                        } else {
                                          setPreviewCount(previewCount + previewCountInit);
                                        }
                                      }}
                                    >
                                      {index !== previewCount - 1 ? (
                                        <>
                                          <div className=" w-full h-full relative">
                                            <Image
                                              width={'100%'}
                                              height={window.innerWidth * 0.4}
                                              className=" rounded-md"
                                              fit="cover"
                                              lazy={true}
                                              src={(item3.minImgUrl || item3.resourcePreviewUrl)
                                                ?.replaceAll('\\', '/')
                                                .replaceAll('D:/_Resource/', bizBaseUrl + '/images/')}
                                              fallback={Fallback}
                                              placeholder={Fallback}
                                            />
                                            <div className=" absolute bottom-1 right-1 bg-black bg-opacity-20 rounded-sm shadow-md px-1">
                                              {index + 1}
                                            </div>
                                          </div>
                                        </>
                                      ) : (
                                        <>
                                          <div className=" text-base ">
                                            查看更多
                                            <span>{'...'}</span>
                                          </div>
                                        </>
                                      )}
                                    </GridItem>
                                  ))}
                              </Grid>
                            </div>
                          ))}
                        </div>
                      </>
                    )}
                    {/* P40Asmrone */}
                    {isP40() && 'tracksList' in fetchPostDetailQuery.data?.postContentDto?.contentInfo && (
                      <>
                        <div className=" flex justify-between text-nowrap flex-wrap pt-2 mx-3">
                          <AsmrBreadcrumb />
                          <div
                            className=" flex text-sm"
                            onClick={() => {
                              if (asmrBreadcrumbList.tarckList.length !== 1) {
                                updateAsmrBreadcrumbList((draft) => {
                                  draft.tarckList.pop();
                                });
                              }
                            }}
                          >
                            <TiArrowBack
                              color="orange"
                              size={20}
                            />
                            上一页
                          </div>
                        </div>
                        <div className=" text-sm my-2 shadow-xl rounded-xl bg-slate-100">
                          {asmrBreadcrumbList.tarckList.length !== 0 &&
                            asmrBreadcrumbList.tarckList.at(-1).children.map((item) => (
                              <div
                                key={'P40_' + item.title}
                                className=" flex flex-row shadow-sm items-center border-b border-slate-300"
                                onClick={() => {
                                  if (item.type === 'folder') {
                                    // 跳转目录 + 修改面包屑导航
                                    updateAsmrBreadcrumbList((draft) => {
                                      // 确保操作的是 draft 对象的副本
                                      const itemCopy = {
                                        ...item,
                                        children: [...item.children],
                                      };
                                      itemCopy.children.sort((a, b) => {
                                        // 先比较 type
                                        const typeComparison = a.type.localeCompare(b.type);
                                        // 如果 type 不同，直接返回比较结果
                                        if (typeComparison !== 0) {
                                          return typeComparison;
                                        }
                                        // 如果 type 相同，比较 title
                                        return a.title.localeCompare(b.title);
                                      });
                                      draft.tarckList.push(itemCopy);
                                    });
                                  } else {
                                    Toast.show('❤ 暂无权限 ❤');
                                    return;
                                    // if (!isFromSesame && !usergroupId) {
                                    //   Toast.show("请先开通VIP");
                                    //   return;
                                    // }
                                    if (item.type === 'audio') {
                                      Toast.show('播放音频' + item.title);
                                      return;
                                    } else if (item.type === 'image') {
                                      Dialog.show({
                                        content: (
                                          <Image
                                            src={img.loadingImg}
                                            fit="cover"
                                          ></Image>
                                        ),
                                        closeOnMaskClick: true,
                                        closeOnAction: true,
                                        bodyStyle: {
                                          width: '80vw', // 页面宽度的 80%
                                          maxWidth: '1200px', // 设置最大宽度
                                          textAlign: 'center',
                                        },
                                        actions: [
                                          {
                                            key: 'open_blank',
                                            text: <span className="text-slate-400 text-base">🔗看大图</span>,
                                          },
                                        ],
                                      });
                                    } else {
                                      Toast.show('下载文件' + item.title);
                                    }
                                  }
                                }}
                              >
                                <div className=" p-2 pl-3">
                                  {/* folder audio image other */}
                                  {item.type === 'folder' ? (
                                    <AiFillFolder
                                      color="#FFC107"
                                      size={40}
                                    />
                                  ) : item.type === 'audio' ? (
                                    <AiFillPlayCircle
                                      color="#1976D2"
                                      size={40}
                                    />
                                  ) : item.type === 'image' ? (
                                    <AiFillFileImage
                                      color="#FF9800"
                                      size={40}
                                    />
                                  ) : (
                                    <AiFillFileText
                                      color="#31CCEC"
                                      size={40}
                                    />
                                  )}
                                </div>
                                <div className=" flex-col text-start p-2 w-full">
                                  <div className=" text-wrap">{item.title}</div>
                                  <div className="grid grid-flow-col justify-items-stretch text-start mt-0.5 ">
                                    {item.type === 'folder' && (
                                      <div>{'子目录: ' + (item.children?.length || '0') + ' 项目'}</div>
                                    )}
                                    {item.type !== 'folder' && (
                                      <div>{'大小: ' + (item?.size ? beautyFileSize(item?.size) : '未知')}</div>
                                    )}
                                    {item.type === 'audio' && (
                                      <div>{'时长: ' + (item.duration ? seconds2Duration(item.duration) : '0s')}</div>
                                    )}
                                    {/* <div>{"哈希: " + (item.hash || "未知")}</div> */}
                                  </div>
                                </div>
                              </div>
                            ))}
                        </div>
                      </>
                    )}
                    {/* P50Bilinovel */}
                    {isP50() && 'volumeList' in fetchPostDetailQuery.data?.postContentDto?.contentInfo && (
                      <>
                        <div className=" text-sm flex-nowrap text-nowrap whitespace-nowrap py-2 rounded-md bg-slate-100 shadow-md">
                          <div className=" flex justify-between mx-2">
                            <div className=" text-start">
                              {'最近更新: ' +
                                (
                                  fetchPostDetailQuery.data as BilinovelPostDetail
                                ).postContentDto.metaInfo.novelRenewDatetime
                                  .toString()
                                  ?.split(' ')?.[0] +
                                ' · 共' +
                                (fetchPostDetailQuery.data as BilinovelPostDetail).postContentDto.metaInfo
                                  .novelTotalVolumeCount +
                                ' 卷 ' +
                                (fetchPostDetailQuery.data as BilinovelPostDetail).postContentDto.metaInfo
                                  .novelTotalChapterCount +
                                ' 章'}
                            </div>
                            <div>倒序 | 正序</div>
                          </div>
                          <div className=" mb-2 p-2 text-start">
                            {(
                              fetchPostDetailQuery.data?.postContentDto.contentInfo as P50BilinovelContentBO
                            ).volumeList.map((volume, index) => (
                              <>
                                <div
                                  key={'P50_' + volume.volumeName}
                                  className=" relative bg-gradient-to-r from-slate-500/80 to-slate-500/30 text-slate-300 text-base text-start p-2 pl-3 rounded-md shadow-md"
                                >
                                  {volume.volumeName}
                                  <div>
                                    <Image
                                      className=" rounded-md"
                                      lazy={true}
                                      width={window.innerWidth * 0.25}
                                      height={window.innerWidth * 0.35}
                                      fit="cover"
                                      style={{
                                        position: 'absolute',
                                        top: 15,
                                        right: 15,
                                      }}
                                      src={volume.volumeCoverUrl
                                        ?.replaceAll('\\', '/')
                                        .replaceAll('D:/_Resource/', bizBaseUrl + '/images/')}
                                      fallback={Fallback}
                                      placeholder={Fallback}
                                    />
                                  </div>
                                </div>
                                <div className=" flex flex-col gap-2 p-1.5 px-3 min-h-40">
                                  {volume.chapterList.map((chapter, index) => (
                                    <div
                                      key={index}
                                      className=" border-b-2 py-1.5"
                                      onClick={() => {
                                        Toast.show('开始阅读章节: ' + volume.volumeName + ' ' + chapter.chapterName);
                                      }}
                                    >
                                      {/* {String(index + 1).padStart(2, "0") + " : "} */}
                                      {chapter.chapterName}
                                    </div>
                                  ))}
                                </div>
                              </>
                            ))}
                          </div>
                        </div>
                      </>
                    )}
                    {/* P60Hentaiclub */}
                    {isP60() && 'postImgCount' in fetchPostDetailQuery.data?.postContentDto?.metaInfo && (
                      <>
                        <div className=" flex-nowrap text-nowrap whitespace-nowrap ">
                          <div className=" mb-2">
                            {new Array(1).fill(0).map((item, index) => (
                              <div key={'P10_' + item.chapterNo}>
                                <div className=" flex justify-between bg-slate-500 text-white rounded-md mb-2 shadow-md">
                                  <div className=" flex justify-center items-center gap-2 m-2">
                                    <div>{'第 ' + (index + 1) + ' 话'}</div>
                                    <div>
                                      {'共 ' +
                                        //@ts-ignore
                                        (fetchPostDetailQuery.data as HentaiclubPostDetail)?.postContentDto?.contentInfo
                                          .chapterList.length +
                                        ' 页'}
                                    </div>
                                  </div>
                                  <div className=" flex justify-center items-center gap-2">
                                    <div
                                      className=" flex justify-center items-center gap-2 bg-red-400 p-2 px-3"
                                      onClick={() => {
                                        toggleShowPreview(!showPreview);
                                      }}
                                    >
                                      <div>{'查看预览'}</div>
                                      <AiOutlineFolderOpen size={22} />
                                    </div>
                                    <div
                                      className=" flex justify-center items-center gap-2 bg-orange-400 rounded-r-md p-2 px-3"
                                      onClick={() => {
                                        // if (!isFromSesame && !usergroupId) {
                                        //   Toast.show("请先开通VIP");
                                        //   return;
                                        // }
                                        navigate('/reader-picture', {
                                          // navigate('/reader-image', {
                                          state: {
                                            postTitle: fetchPostDetailQuery.data?.postTitle,
                                            chapterList:
                                              //@ts-ignore
                                              fetchPostDetailQuery.data?.postContentDto.contentInfo.chapterList,
                                            chapterInex: 0,
                                            imageInex: 0,
                                          },
                                        });
                                      }}
                                    >
                                      <div>{'开始阅读'}</div>
                                      <AiOutlineEye size={22} />
                                    </div>
                                  </div>
                                </div>
                                <Grid
                                  columns={3}
                                  gap={8}
                                  className={[
                                    'bg-gray-400',
                                    'p-2',
                                    'rounded-md',
                                    showPreview ? 'visible' : 'invisible',
                                  ].join(' ')}
                                >
                                  {//@ts-ignore
                                  (
                                    fetchPostDetailQuery.data as HentaiclubPostDetail
                                  )?.postContentDto?.contentInfo.chapterList
                                    .slice(0, previewCount)
                                    .map((item3, index) => (
                                      <GridItem
                                        key={index}
                                        className={[
                                          ' flex justify-center flex-col items-center  text-white rounded-md shadow-md',
                                          index !== previewCount - 1 ? 'bg-slate-400' : 'bg-slate-600',
                                        ].join(' ')}
                                        onClick={() => {
                                          // if (!isFromSesame && !usergroupId) {
                                          //   Toast.show("请先开通VIP");
                                          //   return;
                                          // }
                                          if (index !== previewCount - 1) {
                                            navigate('/reader-picture', {
                                              // navigate('/reader-image', {
                                              state: {
                                                postTitle: fetchPostDetailQuery.data?.postTitle,
                                                chapterList:
                                                  //@ts-ignore
                                                  fetchPostDetailQuery.data?.postContentDto.contentInfo.chapterList,
                                                chapterInex: 0,
                                                imageInex: index,
                                              },
                                            });
                                          } else {
                                            setPreviewCount(previewCount + previewCountInit);
                                          }
                                        }}
                                      >
                                        {index !== previewCount - 1 ? (
                                          <>
                                            <div className=" w-full h-full relative">
                                              <Image
                                                width={'100%'}
                                                height={window.innerWidth * 0.4}
                                                className=" rounded-md"
                                                fit="cover"
                                                lazy={true}
                                                src={(
                                                  item3.minImgUrl ||
                                                  item3.resourcePreviewUrl ||
                                                  item3.resourceRealityUrl
                                                )
                                                  ?.replaceAll('\\', '/')
                                                  .replaceAll('D:/_Resource/', bizBaseUrl + '/images/')}
                                                fallback={Fallback}
                                                placeholder={Fallback}
                                              />
                                              <div className=" absolute bottom-1 right-1 bg-black bg-opacity-20 rounded-sm shadow-md px-1">
                                                {index + 1}
                                              </div>
                                            </div>
                                          </>
                                        ) : (
                                          <>
                                            <div className=" text-base ">
                                              查看更多
                                              <span>{'...'}</span>
                                            </div>
                                          </>
                                        )}
                                      </GridItem>
                                    ))}
                                </Grid>
                              </div>
                            ))}
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                  {isFromSesame && (
                    <>
                      <div className="absolute top-0 text-white w-full h-full px-3 overflow-hidden">
                        <div className=" relative w-full h-full bg-black bg-opacity-70 rounded-md shadow-md ">
                          <div className={' sticky top-40'}>
                            <MaskContent />
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </Swiper.Item>
            )}
            {/* 评论 */}
            {true && (
              <Swiper.Item className=" mb-20">
                <div className=" pt-3">
                  {/* 评论列表 */}
                  <div className=" mx-3 bg-gradient-to-br from-purple-300 to-orange-300  text-base rounded-md shadow-md border border-slate-200">
                    <div className=" flex justify-center items-center gap-2 min-h-96 bg-slate-100 rounded-md shadow-md p-2 m-2">
                      <AiFillCloseCircle size={18} />
                      发布者和会员可见
                    </div>
                  </div>
                </div>
              </Swiper.Item>
            )}
          </Swiper>
          {/* 评论框 */}
          {((activePanelIndex == 3 && getCountOnSourceType(post?.postSourceType)?.hasMenu) ||
            (activePanelIndex == 2 && !getCountOnSourceType(post?.postSourceType)?.hasMenu)) && (
            <div className="fixed p-2 bottom-0 w-full flex justify-between items-center gap-2 bg-black bg-opacity-60 shadow-md backdrop-blur-sm">
              <Image
                src={img.avatar}
                height={35}
                width={35}
                fit="cover"
                className=" rounded-[100%] object-cover shrink-0"
              />
              <input
                placeholder="请输入你的评论"
                className=" px-2 py-1.5 rounded-md text-base shadow-md w-full text-center grow"
              />
              <div
                className=" shrink-0 bg-orange-400 text-white px-2.5 py-1.5 text-base rounded-md shadow-md"
                onClick={() => {
                  Toast.show('❤ 暂无权限 ❤');
                  return;
                }}
              >
                发送
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Detail;
